/* WRC enhancements delegate variant, availability, pricing, gallery and cart actions to Turbo. */
(function () {
  function initNativeProducts(scope) {
    (scope || document).querySelectorAll('[data-wrc-native-product]').forEach(function (root) {
      if (root.dataset.wrcNativeInitialized === 'true') return;
      root.dataset.wrcNativeInitialized = 'true';
    /* WRC CUSTOMIZATION START — accessible Size and Framing dialogs; mapped photos load only when shown. */
    function bindDialog(openSelector, dialogSelector, closeSelector) {
      var dialog = root.querySelector(dialogSelector);
      var open = root.querySelector(openSelector);
      var close = root.querySelector(closeSelector);
      var lastFocus;
      if (!dialog || !open) return;
      open.addEventListener('click', function () {
        lastFocus = document.activeElement;
        dialog.querySelectorAll('[data-wrc-dialog-srcset]').forEach(function (source) {
          if (!source.getAttribute('srcset')) source.setAttribute('srcset', source.dataset.wrcDialogSrcset);
        });
        dialog.querySelectorAll('[data-wrc-dialog-src]').forEach(function (image) {
          if (!image.getAttribute('src')) image.setAttribute('src', image.dataset.wrcDialogSrc);
        });
        dialog.showModal();
      });
      if (close) close.addEventListener('click', function () { dialog.close(); });
      dialog.addEventListener('click', function (event) { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', function () { if (lastFocus) lastFocus.focus(); });
    }
    bindDialog('[data-wrc-native-size-open]', '[data-wrc-native-size-dialog]', '[data-wrc-native-size-close]');
    bindDialog('[data-wrc-native-frame-open]', '[data-wrc-native-frame-dialog]', '[data-wrc-native-frame-close]');
    /* WRC CUSTOMIZATION END */

    var form = root.querySelector('[data-product-form]');
    var nativeButton = form && form.querySelector('[data-wrc-native-atc]');
    var sticky = document.querySelector('[data-wrc-native-sticky]');
    if (form && nativeButton) {
      var stickyButton = sticky && sticky.querySelector('[data-wrc-native-sticky-add]');
      var stickyPrice = sticky && sticky.querySelector('[data-wrc-native-sticky-price]');
      var stickyTitle = sticky && sticky.querySelector('[data-wrc-native-sticky-variant]');
      var buttonText = nativeButton.querySelector('.text');
      var productData;

      try {
        productData = JSON.parse(form.dataset.product);
      } catch (error) {
        productData = null;
      }

      function selectedVariantIsUnavailable() {
        var variantSelect = form.querySelector('select[name="id"]');
        if (!productData || !Array.isArray(productData.variants) || !variantSelect) {
          return nativeButton.disabled || nativeButton.classList.contains('disabled');
        }

        var selectedVariant = productData.variants.find(function (variant) {
          return String(variant.id) === String(variantSelect.value);
        });

        return !selectedVariant || selectedVariant.available !== true;
      }

      /* WRC CUSTOMIZATION START — keep every Size card priced for the selected native option combination. */
      function formatCardMoney(cents, omitTrailingZeros) {
        if (!window.Shopify || typeof window.Shopify.formatMoney !== 'function') return '';
        var formatted = window.Shopify.formatMoney(cents, form.dataset.moneyFormat);
        return omitTrailingZeros ? formatted.replace(/([.,]00)(?!\d)/, '') : formatted;
      }

      function syncSizeCardPrices() {
        if (!productData || !Array.isArray(productData.variants)) return;
        var variantSelect = form.querySelector('select[name="id"]');
        if (!variantSelect) return;
        var selectedVariant = productData.variants.find(function (variant) {
          return String(variant.id) === String(variantSelect.value);
        });
        if (!selectedVariant || !Array.isArray(selectedVariant.options)) return;

        root.querySelectorAll('[data-wrc-size-card]').forEach(function (card) {
          var sizeOptionIndex = Number(card.dataset.wrcSizeOptionIndex);
          var wantedOptions = selectedVariant.options.slice();
          wantedOptions[sizeOptionIndex] = card.dataset.wrcSizeValue;
          var matchingVariant = productData.variants.find(function (variant) {
            return Array.isArray(variant.options) && variant.options.every(function (value, index) {
              return value === wantedOptions[index];
            });
          });
          if (!matchingVariant) return;

          card.querySelectorAll('[data-wrc-size-current]').forEach(function (priceNode) {
            priceNode.textContent = formatCardMoney(matchingVariant.price, true);
          });
          var compareNode = card.querySelector('[data-wrc-size-compare]');
          var hasComparePrice = matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price;
          if (compareNode) {
            compareNode.hidden = !hasComparePrice;
            compareNode.textContent = hasComparePrice ? formatCardMoney(matchingVariant.compare_at_price, true) : '';
          }
          if (matchingVariant.featured_image && matchingVariant.featured_image.src) {
            card.dataset.image = matchingVariant.featured_image.src;
          } else {
            card.removeAttribute('data-image');
          }
        });
      }
      /* WRC CUSTOMIZATION END */

      function syncPurchaseUI() {
        var checked = form.querySelector('.swatch input:checked');
        var priceNode = root.querySelector('[data-price-ui] > .price > .money, [data-price-ui] .price .money, .current_price .money');
        var price = priceNode ? priceNode.textContent.trim() : '';
        var unavailable = selectedVariantIsUnavailable();
        var submitting = !unavailable && (nativeButton.disabled || nativeButton.classList.contains('disabled'));
        var nextLabel = unavailable ? 'SOLD OUT' : 'ADD TO CART' + (price ? ' — ' + price : '');
        if (buttonText && buttonText.textContent.trim() !== nextLabel) buttonText.textContent = nextLabel;
        if (stickyTitle && checked) stickyTitle.textContent = checked.value;
        if (stickyPrice && price) stickyPrice.textContent = price;
        if (stickyButton) {
          stickyButton.disabled = unavailable || submitting;
          if (stickyButton.textContent !== nextLabel) stickyButton.textContent = nextLabel;
        }
        syncSizeCardPrices();
      }

      form.addEventListener('change', function () { window.setTimeout(syncPurchaseUI, 0); });
      new MutationObserver(syncPurchaseUI).observe(nativeButton, { attributes: true, childList: true, subtree: true });
      var priceContainer = root.querySelector('[data-price-ui]');
      if (priceContainer) new MutationObserver(syncPurchaseUI).observe(priceContainer, { childList: true, subtree: true, characterData: true });
      if (stickyButton) stickyButton.addEventListener('click', function () { nativeButton.click(); });
      syncPurchaseUI();
      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { sticky.hidden = entries[0].isIntersecting; }, { threshold: 0 }).observe(nativeButton);
      }
    }

    var gallery = root.querySelector('[data-product-gallery]');
    var counter = root.querySelector('[data-wrc-gallery-counter] span');
    if (gallery && counter) {
      var attempts = 0;
      var connectGalleryCounter = function () {
        var flickity = window.Flickity && window.Flickity.data(gallery);
        if (flickity) {
          var updateCounter = function () { counter.textContent = String(flickity.selectedIndex + 1); };
          flickity.on('select', updateCounter);
          updateCounter();
          return;
        }
        attempts += 1;
        if (attempts < 50) window.setTimeout(connectGalleryCounter, 100);
      };
      connectGalleryCounter();
    }
    });
  }

  function bootNativeProducts() { initNativeProducts(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootNativeProducts);
  else bootNativeProducts();
  document.addEventListener('shopify:section:load', function (event) { initNativeProducts(event.target); });
})();
